import type { Movie } from "@/mocks/movies";
import MovieListItem from "@/components/base/MovieListItem";
import SectionHeader from "@/components/base/SectionHeader";

interface LatestListProps {
  movies: Movie[];
  moreHref?: string;
}

export default function LatestList({ movies, moreHref }: LatestListProps) {
  return (
    <section>
      <SectionHeader title="最新上架" subtitle="刚刚更新的影视资源" moreHref={moreHref} />
      <div className="flex flex-col gap-3">
        {movies.map((movie) => (
          <MovieListItem key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}